import React from 'react';

import {Modal} from "../nimbus/modal";
import {Button} from 'components/button';
import {Header} from 'components/header';

import './confirmationModal.css';

export const ConfirmationModal =
    class extends React.Component {
      constructor(props) {
        super(props);

      }

      render() {
        const {title, content, open, cancelText,
          okText, onCancel, onSuccess, className} = this.props;
        let classes = "confirm-modal " + (className || "");

        return (
            <Modal header={<Header level={1}>{title}
            </Header>}
                   onClose={this.handleCancel}
                   open={open}
                   className={classes}
                   onBackdropClick={this.handleCancel}>

              <div className="modal-container">

                {content}

                <div className="float-right">
                  <Button type="button"
                          variant="link"
                          onClick={onCancel}>{cancelText}</Button>

                  <Button type="submit"
                          variant="primary"
                          onClick={onSuccess}>{okText}</Button>
                </div>
              </div>
            </Modal>
        );
      }
    };